import { ResponsiveTable, Typography } from 'procyon-ui'
import React from 'react'
import { columns, useTopResources } from './TopResources.utils'
import TopResourcesSkeleton from './TopResourcesSkeleton'
import { useDashboardDataProvider } from 'features/dashboard'

export const TopResources = () => {
  const { rowData, startDays } = useTopResources()
  const { overallLoading } = useDashboardDataProvider()

  return (
    <div className='border border-[var(--color-common-border)] bg-[var(--color-common-bg-base)] rounded p-5 w-[100%] h-[480px] overflow-auto'>
      <Typography variant='h4-regular' style={{ color: 'var(--color-font-base)' }}>
        Top Resources
      </Typography>
      <Typography
        style={{ color: '--color-font-light' }}
        className='!text-gray-400'
        variant='body-regular'
      >
        sessions last {startDays} days
      </Typography>
      <div className='mt-6'>
        <ResponsiveTable
          columns={columns()}
          data={rowData}
          pagination={{
            pageSize: 5
          }}
        />
      </div>
    </div>
  )
}

const ResourceTypeMap = {
  AppRole: 'targets',
  Server: 'targets',
  Application: 'applications'
}
